/* eslint-disable */

import Plyr from 'plyr-react'
import 'plyr-react/plyr.css'
import { useEffect } from 'react'
import * as Player from 'plyr'

type mediaType = {
  id: string
  media?: string
  url: string
  title: string
  order: number
}

const useVideoPlayer = ({ data }: { data: mediaType[] }) => {
  const media = data
    .filter(el => ['video', 'youtube', 'audio'].includes(el.media ?? ''))
    .sort((a, b) => a.order - b.order)

  useEffect(() => {
    console.log('plyr reloaded useeffect')
    setTimeout(() => {
      console.log('plyr reloaded setTimeout')
      media.forEach(i => {
        new Player.default(`player_${i.id}`)
      })
    }, 5000)
  }, [])
  //get youtube video id
  const YouTubeGetID = (url: any): string => {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0]
  }
  //return media element
  const MediaSrc = (src: any) => {
    const player = new Player.default(`#player_${src.id}`)
    switch (src.media) {
      case 'video':
        return (
          <Plyr
            source={{
              title: src.title,
              type: 'video',
              sources: [
                {
                  src: src.url,
                },
              ],
            }}
          />
        )
        break
      case 'audio':
        return (
          <Plyr
            source={{
              title: src.title,
              type: 'audio',
              sources: [
                {
                  src: src.url,
                },
              ],
            }}
          />
        )
        break
      case 'youtube':
        return (
          <div className="plyr__video-embed" id={`player_${src.id}`}>
            <Plyr
              source={{
                type: 'video',
                // @ts-ignore
                sources: [{ src: YouTubeGetID(src.url), provider: 'youtube' }],
              }}
            />
          </div>
        )
        break
      default:
        return <div></div>
    }
  }

  return { media, MediaSrc }
}
export default useVideoPlayer
